import React from "react"
import { Box } from "theme-ui"

const VideoEmbed = ({embedCode}) => (
  <Box
    sx={{
      position: "relative",
      width: "100%",
      height: "0px",
      paddingBottom: "56.25%",
      iframe: {
        position: "absolute",
        left: 0,
        top: 0,
        width: "100%",
        height: "100%",
      },
    }}
    dangerouslySetInnerHTML={{ __html: embedCode }}
  />
)

export default VideoEmbed
